module.exports = __webpack_public_path__ + "static/appstore-fa4c6f130402face95d3ee94b0934aeb.png";